import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { IAugmentedJQuery, ISCEService } from 'angular';
import { shouldOfferOptionalFloodCoverage } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('optional-flood-insurance-section', []);

interface OptionalFloodInsuranceSection extends angular.IStrictController {
    title: string;
    description: string;
    icon: string;
    policyInfo: CustomerPolicyInfo;
}

module.component('optionalFloodInsuranceSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: OptionalFloodInsuranceSection, $sce: ISCEService, $element: IAugmentedJQuery) {
        this.$onInit = () => {
            this.title = 'Consider Flood coverage';
            this.icon = 'flood';

            if (!shouldOfferOptionalFloodCoverage(this.policyInfo)) {
                $element.addClass('ng-hide');
            } else {
                const description = `We always do our best to cover you fully, and would be happy to provide you with
                    additional coverage for flood damage through one of our partners. Please call us at 1-877-838-8866
                    or click below`;
                this.description = $sce.trustAsHtml(description);
            }
        };
    }
});

export { module };
